/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InformationExtractionSchemaFieldType } from './InformationExtractionSchemaFieldType';
import {
  InformationExtractionSchemaFieldTypeFromJSON,
  InformationExtractionSchemaFieldTypeFromJSONTyped,
  InformationExtractionSchemaFieldTypeToJSON,
} from './InformationExtractionSchemaFieldType';

/**
 *
 * @export
 * @interface InformationExtractionField
 */
export interface InformationExtractionField {
  /**
   *
   * @type {string}
   * @memberof InformationExtractionField
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof InformationExtractionField
   */
  description: string;
  /**
   *
   * @type {boolean}
   * @memberof InformationExtractionField
   */
  exactMatch?: boolean;
  /**
   *
   * @type {InformationExtractionSchemaFieldType}
   * @memberof InformationExtractionField
   */
  type: InformationExtractionSchemaFieldType;
}

/**
 * Check if a given object implements the InformationExtractionField interface.
 */
export function instanceOfInformationExtractionField(value: object): value is InformationExtractionField {
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('description' in value) || value['description'] === undefined) return false;
  if (!('type' in value) || value['type'] === undefined) return false;
  return true;
}

export function InformationExtractionFieldFromJSON(json: any): InformationExtractionField {
  return InformationExtractionFieldFromJSONTyped(json, false);
}

export function InformationExtractionFieldFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): InformationExtractionField {
  if (json == null) {
    return json;
  }
  return {
    name: json['name'],
    description: json['description'],
    exactMatch: json['exact_match'] == null ? undefined : json['exact_match'],
    type: InformationExtractionSchemaFieldTypeFromJSON(json['type']),
  };
}

export function InformationExtractionFieldToJSON(value?: InformationExtractionField | null): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    description: value['description'],
    exact_match: value['exactMatch'],
    type: InformationExtractionSchemaFieldTypeToJSON(value['type']),
  };
}
